<template>

  <div class="vflex">

    <div class="vflex-row-0 vflex-header p-3">
      <div class="page-title">
        <div class="title">
          <h4>{{ $t('Disqualify reasons') }}</h4>
        </div>
        <div class="btn-row">
          <div class="form-inline">
            <button
              type="button"
              class="btn btn-dark mr-2"
              v-if="selected.length >= 2"
              @click="mergeTags()">
              {{ $tc('merge_n_items', selected.length, { count: selected.length }) }}
              </button>
            <button
              type="button"
              class="btn btn-primary"
              @click="showCreateModal()">
              + {{ $t('New') }}
              </button>
          </div>
        </div>
      </div>
    </div>

    <div class="vflex-row-1 p-3">

      <creating
        v-if="creating"
        height="100%" />

      <div
        class="shurt-conatiner"
        v-if="!creating"
        :class="{'box-loading': loading}">

        <div
          v-if="disqualifyReasons.length"
          class="list-group">
          <a
            v-for="(item, index) in disqualifyReasons"
            :key="index"
            href="javascript:void(0)"
            @click="showEditModal(item)"
            class="list-group-item list-group-item-action">
            <input
              class="m-0 mr-1"
              type="checkbox"
              @click.stop=""
              :value="item._id"
              v-model="selected">
              {{ item.name }}
            </a>
        </div>
        
        <no-results 
          v-if="!disqualifyReasons.length">
          {{ $t('There are no items') }}
        </no-results>

      </div>
    </div>

    <div
      v-if="modal_select"
      class="vflex-row-0">
      <disqualify-reason-form
        :initDisqualifyReason="modal_select" 
        @hideModal="hideModal()" 
        @deleted="loadData(); hideModal()" 
        @saved="loadData(); hideModal()" 
        ></disqualify-reason-form>
    </div>

  </div>

</template>

<script>
import DisqualifyReasonForm from './DisqualifyReasonForm'
import InputKeyword from '@/components/Fields/InputKeyword'

export default {
  name: 'DisqualifyReason',
  components: {
    DisqualifyReasonForm,
    InputKeyword
  },
  data () {
    return {
      creating: true,
      loading: true,
      modal_select: false,
      selected: []
    }
  },
  created () {
    this.loadData()
  },
  computed: {
    disqualifyReasons () {
      return this.$store.getters.getDisqualifyReasons
    }
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      this.loading = true

      let params = {
        sort: 'name',
        limit: 1000
      }

      this.$store
      .dispatch('selectDisqualifyReasons', params)
      .then((result) => {
        this.loading = this.creating = false
      })
    },
    /*
    modal
    */
    showCreateModal () {
      this.modal_select = {}
    },
    showEditModal (item) {
      this.modal_select = item
    },
    hideModal () {
      this.modal_select = false
    },
    /*
    mergeTags
    */
    mergeTags () {
      const mergeAction = () => {
        this.loading = true

        this.$store
        .dispatch('mergeDisqualifyReasons', {disqualifyReasons: this.selected})
        .then((result) => {
          this.selected = []
          this.loadData(1)
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: mergeAction,
        title: 'Deseja realmente unir esses registros?'
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/DisqualifyReason/DisqualifyReason.vue